export function getAnnouncements() {
    return {
        "success": true,
        "data": [
            {
                "_id": "68633590c5e2f7008751b8fb",
                "uid": "6720a49bed59cc0095f81d13",
                "store": "Sparkle Star International - Inhouse",
                "title": "You Wish, We Code!",
                "link": "https://feat-dynamic-form.sapex-frontend.pages.dev/form/6861d834207281b773d1f08c",
                "createdAt": "2025-07-01T09:10:40.012Z",
                "img": "https://prod-timein.s3.ap-southeast-1.amazonaws.com/1751331877798.png",
                "updatedAt": "2025-10-29T11:51:15.390Z",
                "__v": 0,
                "rank": 3,
                "toggle": true
            },
        ]
    }
}